"use client"

import { Disc2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Disc2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Disc2Icon = component(Icon)({ as: Disc2 })
